<app-base-modal
  [title]="editorTextDialogData.modalName"
>
  <mat-form-field
    appearance="outline"
    class="form-field"
    [class.none-pointer-events]="editorTextDialogData.noEdit"
  >
    <mat-label>{{ editorTextDialogData.fieldLabel }}</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      type="text"
      cdkAutosizeMinRows="10"
      cdkAutosizeMaxRows="30"
      [(ngModel)]="editorTextDialogData.content"
    ></textarea>
  </mat-form-field>
  <div class="buttons-container">
    @if (!editorTextDialogData.noEdit) {
      <button
        mat-button
        color="primary"
        (click)="handleValueChange()"
      >
        Сохранить
      </button>
    }
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
